import React from 'react';

import Icon from '../../../../../../../icons/Icon';
import { ICONS } from '../../../../../../../icons';

import scss from './EmptyPreview.module.scss';

function EmptyPreview() {
  return (
    <div className={scss.wrapper}>
      <Icon icon={ICONS.Logo} disableCommonColors disableCommonStyles className={scss.logo} />
    </div>
  );
}

export default EmptyPreview;
